import styled from "styled-components";

const Wrapper = styled.div`
    display: inline-block;
    margin: 0 4px;
`;

export default Wrapper;
